import React from 'react'
import Layout from '../../Layout/Layout';
import au1 from '../../images/au1.PNG'
import au2 from '../../images/au2.PNG'
import au3 from '../../images/au3.PNG'



import { Link } from "react-router-dom";
const AU_EU_dialogue = () => {
  return (
    <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>AU-EU Dialogue</h2></div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>
                        The EU–AU Africa Dialogue Engagements, including the AIEP AU–EU
                         Dialogue in Brussels, were a key part of Moolu Venture Lab's
                          active participation in the Africa–Europe Innovation Platform 
                          (AIEP) and the broader AU–EU collaboration frameworks. These
                           high-level forums brought together crucial stakeholders: 
                           policymakers, innovation agencies, research institutions,
                            and private-sector leaders from both the African and European
                             continents. The goal was to bridge ecosystems and advance a 
                             unified agenda for future-focused, cross-continental collaboration. 
</p>

                <p className='light'>Moolu Venture Lab's contributions to these dialogues were
                     focused on several strategic areas critical to Africa's development and
                      global integration. The Lab worked to strengthen Africa–Europe cross-border
                       collaboration in AI, innovation practices, and the complex process of 
                       research commercialization. Furthermore, the team shared policy-relevant
                        insights derived from its work on key concepts like Data Sovereignty,
                         Talent Sovereignty, and the framework for Nigeria's National Generative AI Policy.</p>


                <p className='light'>Ultimately, Moolu Venture Lab served as a continental representative,
                     actively participating in major discussions on the future of AI as it applies to
                      governance, education, and sustainable economic development. The Lab consistently
                       advocated for equitable partnerships and successfully championed Africa-led 
                       innovation narratives, ensuring the continent's perspectives were central to the 
                       policy agenda. This reinforced Moolu Venture Lab's vital role as a critical bridge
                        connecting African and European innovation ecosystems.</p>
               </div>

                <div className='uk-width-1-2@s'>
                  <img src={au1} />

               </div>
            </div>


            <div className='uk-grid uk-margin-large-top'>
                 <div className='uk-width-1-2@s'>
                    <img src={au2} />
                 </div>

                  <div className='uk-width-1-2@s'>
                    <img src={au3} />
                 </div>
            </div>



        </div>
        </Layout>
  )
}

export default AU_EU_dialogue